import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mapResponse } from '@ngrx/operators';
import { delay, exhaustMap } from 'rxjs';
import { ProductService } from '../../../api/services';
import { productActions } from './product.actions';
import { LoadingState } from '../models/loader.model';

export const productsEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(ProductService)) => {
    return actions$.pipe(
      ofType(productActions.loadProducts),
      exhaustMap((props) =>
        compService.productControllerFindAllProduct({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) => productActions.loadProductsDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              productActions.loadProductsDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: 'Impossibile recuperare i prodotti.' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
export const crateProductEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(ProductService)) => {
    return actions$.pipe(
      ofType(productActions.createProduct),
      exhaustMap((props) =>
        compService.productControllerCreateProduct({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) => productActions.createProductDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              productActions.createProductDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: 'Impossibile creare il prodotto.' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
export const loadProductsCategoryEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(ProductService)) => {
    return actions$.pipe(
      ofType(productActions.loadProductsCategory),
      exhaustMap((props) =>
        compService.productControllerFindAllProductCategory({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              productActions.loadProductsCategoryDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              productActions.loadProductsCategoryDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: 'Impossibile caricare le categorie.' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
